import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { AdminType } from '@/types/administrator';

export const useAdministratorTranslations = () => {
  const { formatMessage } = useIntl();

  const getAdminTypeTranslation = useCallback(
    (adminType: AdminType) => {
      switch (adminType) {
        case 'sysAdmin':
          return formatMessage({ defaultMessage: 'Systemadmin' });
        case 'orgAdmin':
          return formatMessage({ defaultMessage: 'Organisationsadmin' });
        case 'orgBearerManager':
          return formatMessage({
            defaultMessage: 'Organisationsbärarhanterare',
          });
        case 'orgReader':
          return formatMessage({ defaultMessage: 'Organisationsgranskare' });
        case 'deptAdmin':
          return formatMessage({ defaultMessage: 'Avdelningsredigerare' });
        case 'deptBearerManager':
          return formatMessage({ defaultMessage: 'Avdelningsbärarhanterare' });
        case 'deptReader':
          return formatMessage({ defaultMessage: 'Avdelningsgranskare' });
        case 'deptUser':
          return formatMessage({ defaultMessage: 'Avdelningsadmin' });
        default:
          return adminType;
      }
    },
    [formatMessage],
  );

  return getAdminTypeTranslation;
};
